import Cookies from 'js-cookie'
import type { LoginCredentials, RegisterCredentials } from '@/types/auth';
import { jwtDecode } from 'jwt-decode'; // 引入解碼函式
// import { api } from '@/services';
import api from '../services/api' // axios instance
import { LoginResponse, API_ENDPOINTS, JwtClaims } from '@myorg/type-lib';
import { logger } from '@myorg/type-lib';
import axios from 'axios';
import { redirectToClientLogin } from '@/auth/authRedirect';

export async function login(data: LoginCredentials): Promise<LoginResponse> {
  const apiInstance = api();
  
  // 💡 直接從目前的網址列暴力撈出最新的 csrf（不依賴全域變數）
  const urlParams = new URLSearchParams(window.location.search);
  const liveCsrfToken = urlParams.get('csrf') || '';

  console.log('%c[必殺技] 單次請求強行注入的 Token:', 'color: red; font-size: 14px;', liveCsrfToken);

  const res: LoginResponse = await apiInstance.post(
    API_ENDPOINTS.ACCOUNT.LOGIN,
    { ...data }, {
    // 💡 關鍵：寫在單次請求的第三個參數 (config) 裡，這通常具有最高優先權，不易被 defaults 覆蓋
    headers: {
      'X-XSRF-TOKEN': liveCsrfToken,
      'X-CSRF-Token': liveCsrfToken
    }}
  );

  // 2. 拿到我們在 Go 裡面算好的 target 網址
    const redirectUrl = res.data?.redirect_url
    
    if (redirectUrl) {
      console.log('🎉 登入驗證成功！立刻切斷前端請求，執行大跳轉:', redirectUrl)
      
      // 💡 關鍵：直接用原生網址跳轉，這會讓瀏覽器重新整理並跑完 OAuth2 後續流程
      window.location.href = "/user" 
      return res; 
    }

  // await handleAuthSuccess();

  return res;
}

// 定義 Captcha 的回傳型別
export interface CaptchaInitData {
  captchaId: string;
  bg: string;
  slice: string;
  target: number;
  y: number;
}

/**
 * 初始化驗證碼目標
 */
export const initCaptcha = async (): Promise<CaptchaInitData | undefined> => {
  try {
    // 注意：使用 api() 通常已經處理過 response 攔截，直接拿 data
    const res = await api().get('/api/go-bff-service/public/captcha/init');

    if (res && res.data && res.data.data) {
      return res.data.data as CaptchaInitData;
    }

    return undefined;
  } catch (err) {
    console.error("驗證碼初始化失敗", err);
    throw err; // 拋出錯誤讓組件能處理 UI 狀態
  }
};

export const logout = async () => {
  try {
    // 注意：使用 api() 通常已經處理過 response 攔截，直接拿 data
    const res = await api().post('/api/client/logout');
    redirectToClientLogin()

  } catch (err) {
    console.error('登出失敗:', err);
  } finally {

  }
};

export async function register(
  data: RegisterCredentials
): Promise<LoginResponse> {
  const res: LoginResponse = await api().post(
    API_ENDPOINTS.ACCOUNT.REGISTER,
    { ...data }
  );

  await handleAuthSuccess();

  return res;
}

export async function handleAuthSuccess() {
  const res = await api().get(API_ENDPOINTS.CLIENT.ME);
  const userData = res.data;

  // 防禦 1：確保 userData 存在
  if (!userData) {
    throw new Error('後端回傳資料為空 (Empty User Data)');
  }

  const { userId, roles, merchantId, name } = userData;

  // 防禦 2：安全地處理 roles，如果不存在或不是字串，就給個預設陣列
  let rolesArray = [];
  if (typeof roles === 'string' && roles.trim() !== '') {
    rolesArray = roles.split(",");
  } else if (Array.isArray(roles)) {
    rolesArray = roles; // 如果後端哪天改成直接給陣列，相容它
  }

  const jsonString = JSON.stringify(rolesArray);

  // 防禦 3：確保有值才塞進 localStorage，避免塞入 "undefined" 字串
  if (userId) localStorage.setItem('userId', userId);
  if (merchantId) localStorage.setItem('merchantId', merchantId);
  if (name) localStorage.setItem('username', name);
  localStorage.setItem('userRoles', jsonString);
}